import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  password: string;
};

export const setPartnerPassword = async (params: Params): Promise<void> => {
  const fetchURL = getM8PartnerURL('setPartnerPassword');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
